import { css } from '@emotion/react'

import { size } from '@twisto/styles'

export const header = css`
  gap: clamp(${size[8]}, 1vw + ${size[4]}, ${size[12]});
`

export const icon = css`
  width: ${size[24]};
  height: ${size[24]};
`
